<template>
    <div class="historys">
        <cube-page type="historys-view" title="我的兑换码">
            <div slot="content">
                <van-tabs v-model="active" :color="gcfg.BackgroundColor">
                    <van-tab title="领取的兑换码">
                        <div class="van-coupon-list__list">
                            <div class="van-coupon" v-for="(item, idx) in qrdata" :key="idx" >
                                <div class="van-coupon__content">
                                    <div class="van-coupon__head" v-if="item.qrscoreactivity.exchange_typedata=='score'">
                                        <h2>{{item.qrscoreactivity.score_numnumber}}<span>积分</span></h2>
                                        <p>积分兑换商品</p>
                                    </div>
                                    <div class="van-coupon__head" v-else>
                                        <h2>{{item.qrscoreactivity.exchange_numnumber}}<span>个资格</span></h2>
                                        <p>资格兑换商品</p>
                                    </div>
                                    <div class="van-coupon__body"><h2>{{item.qrscoreactivity.titletext}}</h2>
                                        <p>活动有效期：{{item.qrscoreactivity.starttime_text}} - {{item.qrscoreactivity.endtime_text}}</p>
                                    </div>
                                </div>
                                <p class="van-coupon__description">兑换码：{{item.qr_src}}  使用时间：{{item.usetime}}</p>
                            </div>
                        </div>
                    </van-tab>

                    <van-tab title="活动剩余兑换量">
                        <div class="van-coupon-list__list">
                            <div class="van-coupon" v-for="(item, idx) in converdata" :key="idx" >
                                <div class="van-coupon__content">
                                    <div class="van-coupon__head" v-if="item.exchangedata=='score'">
                                        <h2>{{item.countnumber}}<span>积分</span></h2>
                                        <p>积分兑换商品</p>
                                    </div>
                                    <div class="van-coupon__head" v-else>
                                        <h2>{{item.countnumber}}<span>个资格</span></h2>
                                        <p>资格兑换商品</p>
                                    </div>
                                    <div class="van-coupon__body"><h2>{{item.qrcodeshopactivity.titletext}}</h2>
                                        <p>活动有效期：{{item.qrcodeshopactivity.starttime_text}} - {{item.qrcodeshopactivity.endtime_text}}</p>
                                    </div>
                                </div>
                                <div class="van-coupon__description">
                                 <p>请在活动期间使用完，剩余资格</p>
<!--                                  v-if="item.countnumber>0"-->
                                  <van-button v-if="item.countnumber>0"  class="van-button van-button--danger van-button--mini now-exchange"  @click="Showactgoodlist(item)" type="info" >立即兑换</van-button>
                                </div>

                            </div>
                        </div>
                    </van-tab>
                </van-tabs>
            </div>
        </cube-page>
    </div>
</template>

<script>
    import CubePage from './TP/cube-page.vue'
    import * as util from '@/utils/network'

    export default {
        components: {
            CubePage,
        },
        data() {
            return {
                converdata: null,
                qrdata: null,
                active: 0,
                gcfg:[]
            };
        },
      methods: {
        showmyqrcode: function () {
          this.$router.push({path: 'showactmy/showacthistory', query: {token: this.$route.query.token}})
        },
        Showactgoodlist(item){
          this.$router.push({name: 'Showactgoodlist', query: {actid: item.activity_id}})
        }
      },
        created: function () {
            this.gcfg = this.$store.getters.getGcfg
            //获得地址数据
            let that = this;
            var url = "/addons/qrcodeshop/api.code/my_codelist_convertlist"
            util.get(url, {},
                function (result) {
                    console.log(result.data)
                    that.qrdata = result.data.qrdata
                    that.converdata = result.data.converdata

                    that.qrdata.forEach(function(item,index,arr){
                        that.qrdata[index].qrscoreactivity.endtime_text = that.qrdata[index].qrscoreactivity.endtime_text.substring(0,10)
                        that.qrdata[index].qrscoreactivity.starttime_text = that.qrdata[index].qrscoreactivity.starttime_text.substring(0,10)
                    })

                    that.converdata.forEach(function(item,index,arr){
                        that.converdata[index].qrcodeshopactivity.endtime_text = that.converdata[index].qrcodeshopactivity.endtime_text.substring(0,10)
                        that.converdata[index].qrcodeshopactivity.starttime_text = that.converdata[index].qrcodeshopactivity.starttime_text.substring(0,10)
                    })
                },
            );
        },
        "$store.state.gcfg": function(){
            this.gcfg = this.$store.getters.getGcfg
        },
    }
</script>

<style scoped>
    .historys {
        height: 100%;
        position: absolute;
        width: 100%;
        top: 0;
        z-index: 28;
    }

    .historys .cube-page > .wrapper .content {
        margin: 0;
    }
    .van-coupon__description{
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }
    .now-exchange{
      width: 80px !important;
    }
</style>